export default "__VITE_ASSET__6e964edb__"